<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import NestedQuote from '$lib/Components/Layout/NestedQuote/NestedQuote.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import ChartEnergyEfficiency from '$lib/PageSections/Charts/ChartEnergyEfficiency/ChartEnergyEfficiency.svelte';
	import CustomerStory from '$lib/PageSections/CustomerStory/CustomerStory.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';

	import ProductRecommendation from '$lib/PageSections/Products/ProductRecommendation.svelte';

	import { UvProduct } from '$lib/data/products/products-data.js';

	import { uvCustomerStory } from '$routes/(public)/resources/case-studies/customer-stories.js';
	import carpetSunlightImage from './images/carpetSunlight.jpg';
</script>

<Section>
	<h2 class="text-left">How UV Rays Lead To Fading &amp; Sun Damage</h2>
	<p class="text-left">
		UV rays, more than any other kind of heat and light, is the biggest cause of
		fading of furniture and wood floors. UV radiation is harmful to your
		furniture, art, and floors - it can even be harmful to your health!
	</p>

	<Image src={carpetSunlightImage} loading="eager" />

	<h2 class="text-left">Block UV Rays with Indow UV Blocking Inserts</h2>
	<p class="text-left">
		With our Museum Grade acrylic glazing, our <a
			href="/products/uv-blocking-window-inserts">UV Blocking Window Inserts</a
		> block 98% of UV rays coming through your windows, protecting your priceless
		art, heirlooms, and wood floors from fading over time.
	</p>

	<NestedQuote
		quote="To use Indow Museum Grade, where you can extend the life of the floors another 10-15 years between re-finishings, financially, it makes a lot of sense."
		name="Scott Sidler"
		label="The Craftsman Blog"
		class="max-w-2xl"
	/>
	<p class="text-left">
		But the best part? They blend in with your existing window frames and let
		other light flow in freely. In fact, once you install them, you might even
		forget they were there!
	</p>
</Section>

<CustomerStory story={uvCustomerStory} />

<Section>
	<h2 class="text-left">More Quiet, More Comfort, More Savings</h2>
	<p class="text-left">
		In addition to blocking 98% of UV rays, Indow UV Blocking Inserts also
		provide significant <a href="/solutions/window-noise-reduction"
			>noise reduction</a
		>
		- keeping your home up to 50% quieter - and keeping your home's temperature more
		stable,
		<a href="/solutions/lower-energy-bills"
			>reducing energy use an average of 20%</a
		>. It's a win-win-win for your pocket book, the planet, and your priceless
		belongings.
	</p>
	<p class="text-left">
		Our air-tight seal not only keeps noise out and your ideal temperature in,
		but it also <a href="/solutions/prevent-window-condensation"
			>reduces condensation</a
		>
		and
		<a href="/solutions/block-pollen-and-pollutants"
			>blocks dust, pollen, and other airborne particles</a
		>. But that doesn't mean you'll have to live in a hermetically sealed home!
		With a gentle tug on the provided D-ring, you can break the seal and remove
		the inserts whenever you want to open your windows and let in some fresh
		air.
	</p>
</Section>

<ProductRecommendation product={UvProduct} />

<Section backgroundColor="grey-light">
	<h3 class="text-indow-grey-dark">Indow vs Replacement Windows</h3>
	<p>
		Adding Indow inserts to an existing window can make your windows perform as
		well (or better!) than a replacement window, but at a fraction of the cost
		and without the hassle and disruption of installing new windows.
	</p>
	<ChartEnergyEfficiency />
</Section>

<TrustedChoice />
<Reviews />
<GetAFreeEstimate />
